import { css } from "styled-components";

// Convert hex to rgba
export const hex2rgba = (hex, alpha = 1) => {
    const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
};

// Create styles inside React Component
export const makeStyles = cb => () => cb && cb(css);